import { render, staticRenderFns } from "./FormAddKommentar.vue?vue&type=template&id=3498fdf9"
import script from "./FormAddKommentar.vue?vue&type=script&lang=js"
export * from "./FormAddKommentar.vue?vue&type=script&lang=js"
import style0 from "./FormAddKommentar.vue?vue&type=style&index=0&id=3498fdf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports